module.exports = __webpack_public_path__ + "cae742f5e1b7266ee7b8f8bf2c771e9e.png";